<template>
  <div
      v-if="bypassFormVisible"
      class="bypass-reason"
      :bypassFormVisible.sync="bypassFormVisible">
    <div style="width: 45%; padding-bottom: 32px;">
      <div class="warning-img">
        <img
            src="../../../assets/warning-icon.svg"
            style="height: 48px; width: 48px; margin-bottom: 8px;">
      </div>
      <div class="heading">
        Select the bypass reason.
      </div>
      <div style="word-break: break-word;">
        <div>
          Please select the reason for warranty requirement bypass.
        </div>
      </div>
    </div>
    <div>
      <el-select
          v-model="selectedBypassReason"
          class="bypass-reason-select"
          placeholder="Select reason"
          popper-class="select-replacement-reason-dropdown"
          @change="sendBypassReason">
        <el-option
            v-for="reason in bypassReasons"
            :key="reason"
            class="select-replacement-reason-option"
            :label="reason"
            :value="reason">
          <span style="float: left">{{ reason }}</span>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "BypassReason",
  props: {
    bypassFormVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedBypassReason: "",
      bypassReasons: [
        "Ring Assist +",
        "Systems Issue",
        "Ongoing, Unresolved Issue",
        "Theft",
        "Specialty Teams Exception (NA, S2T2, NSE, Trending Only)",
      ],
    };
  },
  methods: {
    sendBypassReason(reason) {
      this.$emit("set-bypass-reason", reason);
    },
  },
};
</script>

<style>
.bypass-reason {
  color: #424242;
  font-family: Equip;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;

  .heading {
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    margin-bottom: 8px;
  }

  .warning-img {
    flex-direction: column;
    align-self: flex-start;
    display: flex;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  .bypass-reason-select {
    width: 570px !important;
    display: flex;
    height: 48px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
}
</style>
